<div>
  <nx-pageTitle-box
  [label]="resource?.number + '/ ' + resource?.name"
  [bcRootLvlLabel]="'rentModule.resourceViewComponent.breadcrumb.root' | translate"
  [bcRootLvlPath]="'/resources'"
  [icon]="'icon-item icon'"
  [iconToolTip]="">
    <ng-template nxTemplate="end">
      <nx-default-button *ngIf="this.rolesService.hasRole('nexcore_resource_update')"
        (click)="editResource()"
        [tooltip]="'rentModule.resourceViewComponent.editTooltip' | translate"
        [icon]="'icon-edit'">
      </nx-default-button>
    </ng-template>
  </nx-pageTitle-box>
  <div class="bodyWrapper flex flex-row gap-5">
    <div class="basis-2/3 mt-[10px] widthFixForTable">
      <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">
        <p-tabPanel [header]="'rentModule.resourceViewComponent.tabs.orders' | translate">
          <div class="mt-[1.25rem]">
            <app-resource-assignments-list
              [resource]="resource"
              *ngIf="resource">
            </app-resource-assignments-list>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Vorgänge">
          <div class="mt-[1.25rem]">
            <app-issue-list
              [showTabs]="false"
              [targetEntityType]="'Resource'"
              [targetEntityId]="resource?.id"
              [showPageTitle]="false"
              *ngIf="resource">
            </app-issue-list>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
      <div class="basis-1/3 mt-[11px]">
        <div class="flex flex-col">
          <div class="basis-full">
            <div>
              <nx-headline-box class="mb-2" [label]="'rentModule.resourceViewComponent.sections.general' | translate" appearance="underline"
              class="mb-[1.25rem]">
              </nx-headline-box>
              <nx-headline-box [label]="'rentModule.resourceViewComponent.sections.resourceData' | translate">
              </nx-headline-box>
              <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.resourceViewComponent.fields.number' | translate">
                {{resource?.number? resource.number: '-'}}
              </nx-default-box>
              <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.resourceViewComponent.fields.name' | translate">
                {{resource?.name? resource?.name: '-'}}
              </nx-default-box>
              <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.resourceViewComponent.fields.function' | translate">
                {{functionName? functionName: '-'}}
              </nx-default-box>
              <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.resourceViewComponent.fields.location' | translate">
                {{resource?.location? resource?.location?.name : '-'}}
              </nx-default-box>
            </div>
            <div *ngFor="let section of customAttributeSections; let index = index; let isLast = last" class="mt-2">
              <nx-headline-box
                [label]="section?.label">
              </nx-headline-box>
              <nx-default-box
                *ngFor="let defintion of section?.customAttributeDefinitions; let isLast = last"
                class="bg-white border-b border-gray"
                [label]="defintion?.label">
                <ng-container
                  *ngIf="defintion?.type !== 'DATETIME'">
                  {{getValue(defintion?.id)}}
                </ng-container>
                <ng-container
                  *ngIf="defintion?.type === 'DATETIME'">
                  (getValue(defintion?.id) | date:'dd.MM.yyyy HH:mm')
                </ng-container>
              </nx-default-box>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>

